"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function HeroIntroduction() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section id="hero-introduction" ref={sectionRef} className="relative flex min-h-[90vh] w-full flex-col overflow-hidden bg-background lg:flex-row">
      {}
      <div className={cn("relative h-[50vh] w-full lg:h-auto lg:w-3/5", "transition-opacity duration-1000 ease-out", isVisible ? "opacity-100" : "opacity-0")}>
        <div className="absolute inset-0 bg-black/5 !bg-[url(https://equipped-jaguar.10web.cloud/wp-content/uploads/2026/02/IMG_2981.jpeg)] !h-[400px]" /> {}
        
      </div>

      {}
      <div className="flex w-full flex-col justify-center bg-background ![padding:80px_24px_64px_24px] lg:w-2/5">
        <div className={cn("flex flex-col gap-y-6 transition-all duration-1000 delay-300 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
          <h1 className="font-sans font-bold leading-tight tracking-tight text-foreground !text-6xl !text-left">The Authority in Construction</h1>

          <div className="h-1 w-24 bg-primary" />

          <p className="max-w-md text-lg leading-relaxed text-muted-foreground !not-italic sm:text-xl">With over 20 years of experience, I have dedicated my life to the art of construction. My mission is to empower home owners so they believe they can make the right decision.  </p>

          
        </div>
      </div>
    </section>;
}